module.exports = __webpack_public_path__ + "img/newLimit.cf03d4ea.png";